<template>
  <div class="row">
    <Loading />
    <nav class="d-none d-md-block bg-white sidebar" :class="sideBarGridClasses.leftSideClass">
      <div class="sidebar-sticky">
        <PortalTarget name="lefSideBar">
          <SideBarContainer />
        </PortalTarget>
      </div>
    </nav>

    <main role="main" class="ml-sm-auto col-lg-10 px-4" :class="sideBarGridClasses.rightSideClass">
      <slot />
    </main>
  </div>
</template>

<script>
import SideBarContainer from '@/components/sidebars/SideBarContainer.vue';
import Loading from '@/views/layouts/Loading.vue';
import { loggedIn } from '@/helpers/Authentication.js';
import { PortalTarget } from 'portal-vue';

export default {
  components: {
    SideBarContainer,
    PortalTarget,
    Loading,
  },
  computed: {
    ...loggedIn,
    sideBarGridClasses() {
      let leftSideClass = this.loggedIn ? 'col-md-2' : 'col-md-3';
      let rightSideClass = this.loggedIn ? 'col-md-10' : 'col-md-9';

      return {
        leftSideClass,
        rightSideClass,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-portal-target {
  height: 100%;
}
</style>
